export default __webpack_public_path__ + "static/prodejna-7fc281b23394664f055dfa94b4b077fa.jpg";